export enum RuleTypeEnum {
  Entity = 'Entity',
  ScheduledTask = 'ScheduledTask'
}
